// extracted by mini-css-extract-plugin
export default {"notification-column":"notification-column","notification-col-wrapper":"notification-col-wrapper","exclamation-icon":"exclamation-icon","notification-column-container":"notification-column-container","action-badge":"action-badge","ant-badge-count":"ant-badge-count","ant-scroll-number-only":"ant-scroll-number-only","parentNode":"parentNode","expanded-row":"expanded-row"};
    if(module.hot) {
      // 1793340207473
      var cssReload = require("/home/vsts/work/1/s/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  